export default __webpack_public_path__ + "static/media/bg-publish.cbab4dd6.svg";